// Typ, nie moduł: `import type` znika przy transpilacji, więc test w środowisku
// node nie ciągnie za sobą `@tanstack/charts`.
import type { FunnelStep } from '@/components/charts/FunnelSankeyChart.tsx';
import { CHART_PALETTE } from '@/components/ui/chartPalette.ts';
import { KeyedStatSegmentDto } from '@/types/stats/StatSegmentDto.ts';
import { reportStatsContractBreach } from '@/types/stats/statsContract.ts';

export interface FunnelStepPresentation {
  label: string;
  color: string;
}

export type FunnelStepRegistry = Record<string, FunnelStepPresentation>;

const stepPresentation = (
  key: string,
  registry: FunnelStepRegistry,
): FunnelStepPresentation => {
  const entry = registry[key];
  if (entry) return entry;

  reportStatsContractBreach(
    `Nieznany próg lejka: "${key}". Dopisz go do rejestru widgetu.`,
  );
  return { label: key, color: CHART_PALETTE.muted };
};

/**
 * Progi z kontraktu na progi wykresu. **Tutaj** ucinany jest odpływ poniżej
 * zera: backend nie wymusza monotoniczności lejka (pierwsze progi liczą sesje
 * przeglądarki, dalsze rekordy rezerwacji), a ujemna szerokość wstążki
 * wywróciłaby diagram.
 */
export const funnelToSteps = (
  stages: KeyedStatSegmentDto[],
  registry: FunnelStepRegistry,
): FunnelStep[] =>
  stages.map((stage, index) => {
    const next = stages[index + 1];
    const { label, color } = stepPresentation(stage.key, registry);

    return {
      id: stage.key,
      label,
      count: stage.value,
      drop: next ? Math.max(0, stage.value - next.value) : 0,
      color,
    };
  });
